import axios from "axios";

import { TradingTotalsReportFunction, TradingTotalReportResponse } from "models/functionModels/reportFunctions/TradingTotalsReportFunction";

export const getTradingTotalsReport = async function GetTradingTotalsReport(params: TradingTotalsReportFunction): Promise<TradingTotalReportResponse> {
        const response = await axios.post(`api/v1/Reports/TradingTotals`,
        {...params}, { params: { }, headers: { "Content-Encoding": "gzip" }});
        return response.data;   
}

export const getTradingTotalsReportExport = async function GetTradingTotalsReport(params: TradingTotalsReportFunction) {
        axios.post(`api/v1/Reports/TradingTotalsExport`, 
        {...params}, { params: { }, headers: { "Content-Encoding": "gzip" }, responseType : "blob"}).then(response =>{


                const xslxBlob = new Blob([response.data], { type: "application/xslx" });
                const url = window.URL.createObjectURL(xslxBlob);
                const tempLink = document.createElement("a");
                tempLink.href = url;
                tempLink.setAttribute(
                "download",
                "TradingTotals_"+ new Date().toLocaleDateString('en-AU', {
                        day : 'numeric',
                        month : 'short',
                        year : 'numeric',
                        hour : '2-digit',
                        minute : '2-digit'
                    }).split(' ').join('-').replace(',', '') +".xlsx"
                );
                document.body.appendChild(tempLink);
                tempLink.click();
        
                // Clean up the temporary elements and URL
                document.body.removeChild(tempLink);
                window.URL.revokeObjectURL(url);
        });     
}

export const getNormalSalesReportExport = async function GetTradingTotalsReport(params: any, reportName: string, reportDescription: string) {
        params.exportType = "xlsx";
        params.reportName = reportName;
        params.reportDescription = reportDescription;
        axios.post(`api/v1/Reports/SalesReportNormalExport`, 
        {...params}, { params: { }, headers: { "Content-Encoding": "gzip" }, responseType : "blob"}).then(response =>{
                const xslxBlob = new Blob([response.data], { type: "application/xslx" });
                const url = window.URL.createObjectURL(xslxBlob);
                const tempLink = document.createElement("a");
                tempLink.href = url;
                tempLink.setAttribute(
                "download",
                reportName+"_"+ new Date().toLocaleDateString('en-AU', {
                        day : 'numeric',
                        month : 'short',
                        year : 'numeric',
                        hour : '2-digit',
                        minute : '2-digit'
                    }).split(' ').join('-').replace(',', '') +".xlsx"
                );
                document.body.appendChild(tempLink);
                tempLink.click();
        
                // Clean up the temporary elements and URL
                document.body.removeChild(tempLink);
                window.URL.revokeObjectURL(url);
        });    
}

export const getExportStockReport = async function GetExportStockReport(params: any, reportName: string, reportDescription: string) {
        params.exportType = "xlsx";
        params.reportName = reportName;
        params.reportDescription = reportDescription;
        axios.post(`api/v1/Reports/exportStockReport`, 
        {...params}, { params: { }, headers: { "Content-Encoding": "gzip" }, responseType : "blob"}).then(response =>{
                const xslxBlob = new Blob([response.data], { type: "application/xslx" });
                const url = window.URL.createObjectURL(xslxBlob);
                const tempLink = document.createElement("a");
                tempLink.href = url;
                tempLink.setAttribute(
                "download",
                reportName+"_"+ new Date().toLocaleDateString('en-AU', {
                        day : 'numeric',
                        month : 'short',
                        year : 'numeric',
                        hour : '2-digit',
                        minute : '2-digit'
                        }).split(' ').join('-').replace(',', '') +".xlsx"
                );
                document.body.appendChild(tempLink);
                tempLink.click();
        
                // Clean up the temporary elements and URL
                document.body.removeChild(tempLink);
                window.URL.revokeObjectURL(url);
        });
};